import {Cureus} from '../Cureus';

Cureus.ArticleRating= {}
//= require_tree ./ArticleRating